var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
const BlockButton = props => {
    const { as, onClick } = props, rest = __rest(props, ["as", "onClick"]);
    const Element = as || 'span';
    const keyDown = useCallback((event, ...more) => {
        if (onClick && (event.keyCode === 13 || event.keyCode === 32)) {
            event.preventDefault();
            onClick(event, ...more);
        }
    }, [onClick]);
    return (React.createElement(Element, Object.assign({ tabIndex: '0', role: 'button', onKeyDown: keyDown, onClick: onClick }, rest)));
};
export default BlockButton;
BlockButton.propTypes = {
    onClick: PropTypes.func,
    as: PropTypes.string,
};
